import React, { useState, useEffect } from "react";
import { Link } from 'react-router-dom';
import { Modal, Dropdown } from 'react-bootstrap';

import MaterialTable from "@material-table/core";
import { ExportCsv, ExportPdf } from "@material-table/exporters";
import btcicon from "../../../icons/crypto/btc.svg";
import ethicon from "../../../icons/crypto/eth.svg";
import usdticon from "../../../icons/crypto/usdt.svg";
import usdcicon from "../../../icons/crypto/usdc.svg";
import { CopyToClipboard } from "react-copy-to-clipboard";

import { useTranslation } from "react-i18next";
import Loader from '../../pages/Loader';
import axios from 'axios';
import moment from 'moment';
import validator from 'validator';
import Snackbars from '../../pages/Snackbars';

import jsPDF from 'jspdf';
import { CsvBuilder } from 'filefy';
import 'jspdf-autotable';
import { checkauhtoken } from '../../../api/PrePageLoad';
import { formatBalance } from "../../../utils";

const defaultSymbols = [
    {
        proName: "FOREXCOM:SPXUSD",
        title: "S&P 500",
    },
    {
        proName: "FOREXCOM:NSXUSD",
        title: "Nasdaq 100",
    },
    {
        proName: "FX_IDC:EURUSD",
        title: "EUR/USD",
    },
    {
        proName: "BITSTAMP:BTCUSD",
        title: "BTC/USD",
    },
    {
        proName: "BITSTAMP:ETHUSD",
        title: "ETH/USD",
    },
];


export const Crypto_Exchanges = () => {
    const { t } = useTranslation();
    const [error, setError] = useState(false);
    const [error_msg, setErrorMsg] = useState("");
    const [success, setSuccess] = useState(false);
    const [success_msg, setSuccessMsg] = useState("");
    const [loader, setLoader] = useState(false);
    const [allaccount, setAllaccount] = useState([]);
    const [allcrypto, setAllcrypto] = useState([]);

    const [exchnagetra, setexchnagetra] = useState([]);
    const [swaptra, setswaptra] = useState([]);

    const [buy_crypto, setbuy_crypto] = useState("");
    const [buy_crypto_error, setbuy_crypto_error] = useState("");

    const [sell_crypto, setsell_crypto] = useState("");
    const [sell_crypto_error, setsell_crypto_error] = useState("");

    const [swap_from_crypto, setswap_from_crypto] = useState("");
    const [swap_from_crypto_error, setswap_from_crypto_error] = useState("");

    const [swap_to_crypto, setswap_to_crypto] = useState("");
    const [swap_to_crypto_error, setswap_to_crypto_error] = useState("");

    const [buy_account, setbuy_account] = useState("");
    const [buy_account_error, setbuy_account_error] = useState("");

    const [sell_account, setsell_account] = useState("");
    const [sell_account_error, setsell_account_error] = useState("");

    const [buy_amount, setbuy_amount] = useState("");
    const [buy_amount_error, setbuy_amount_error] = useState("");

    const [sell_amount, setsell_amount] = useState("");
    const [sell_amount_error, setsell_amount_error] = useState("");

    const [swap_amount, setswap_amount] = useState("");
    const [swap_amount_error, setswap_amount_error] = useState("");
    const [amountbanner, setamountbanner] = useState("");
    

    const [activeToggle, setActiveToggle] = useState("posts");
    const [OTPVerification, setOTPVerification] = useState(false);
    const [OTPVerificationSell, setOTPVerificationSell] = useState(false);
    const [OTPVerificationSwap, setOTPVerificationSwap] = useState(false);
    const [TransactionDetails, setTransactionDetails] = useState(false);

    const [SMSOTPVerification, setSMSOTPVerification] = useState(false);
    const [SMSOTPVerificationSell, setSMSOTPVerificationSell] = useState(false);
    const [SMSOTPVerificationSwap, setSMSOTPVerificationSwap] = useState(false);

    const [buy_acc_div, setbuy_acc_div] = useState(false);
    const [buy_crypto_div, setbuy_crypto_div] = useState(false);
    const [buy_usd_value, setbuy_usd_value] = useState(0);
    const [buy_euro_value, setbuy_euro_value] = useState(0);
    const [buy_coin_name, setbuy_coin_name] = useState("");
    const [buy_select_value, setbuy_select_value] = useState(0);
    const [buy_debit_amount, setbuy_debit_amount] = useState(0);
    const [buy_credit_currency, setbuy_credit_currency] = useState(0);
    const [buy_debit_currency, setbuy_debit_currency] = useState(0);
    const [exchangerate1, setexchangerate1] = useState("");


    const [buy_select_fee, setbuy_select_fee] = useState(0);
    const [buy_select_acc, setbuy_select_acc] = useState("");


    const [sell_acc_div, setsell_acc_div] = useState(false);
    const [sell_crypto_div, setsell_crypto_div] = useState(false);
    const [sell_usd_value, setsell_usd_value] = useState(0);
    const [sell_euro_value, setsell_euro_value] = useState(0);
    const [sell_coin_name, setsell_coin_name] = useState("");
    const [sell_select_value, setsell_select_value] = useState(0);
    const [sell_select_acc, setsell_select_acc] = useState("");

    const [swap_coin_name, setswap_coin_name] = useState("");
    const [swap_coin_amount, setswap_coin_amount] = useState(0);

    const [exchangerate, setexchangerate] = useState(0);
    const [google_auth, setgoogle_auth] = useState("");
    const [google_auth_error, setgoogle_auth_error] = useState("");
    const [google_auth_sell, setgoogle_auth_sell] = useState("");
    const [google_auth_sell_error, setgoogle_auth_sell_error] = useState("");

    const [google_auth_swap, setgoogle_auth_swap] = useState("");
    const [google_auth_swap_error, setgoogle_auth_swap_error] = useState("");

    const [swap_popup_from_value, setswap_popup_from_value] = useState(0);
    const [swap_popup_to_value, setswap_popup_to_value] = useState(0);

    const [buyminamount, setbuyminamount] = useState("");
    const [buymaxamount, setbuymaxamount] = useState("");

    const [sellminamount, setsellminamount] = useState("");
    const [sellmaxamount, setsellmaxamount] = useState("");

    const [swapminamount, setswapminamount] = useState("");
    const [swapmaxamount, setswapmaxamount] = useState("");


    const [buyotp, setbuyotp] = useState("");
    const [sellotp, setsellotp] = useState("");
    const [swapotp, setswapotp] = useState("");

    const [buyotpmessage, setbuyotpmessage] = useState("");
    const [buyotpmessage_error, setbuyotpmessage_error] = useState("");

    const [sellotpmessage, setsellotpmessage] = useState("");
    const [sellotpmessage_error, setsellotpmessage_error] = useState("");

    const [swapotpmessage, setswapotpmessage] = useState("");
    const [swapotpmessage_error, setswapotpmessage_error] = useState("");




    const [error_display_amount_buy, seterror_display_amount_buy] = useState("");
    const [error_display_details_buy, seterror_display_details_buy] = useState("");

    const [error_display_amount_sell, seterror_display_amount_sell] = useState("");
    const [error_display_details_sell, seterror_display_details_sell] = useState("");

    const [error_display_amount_swap, seterror_display_amount_swap] = useState("");
    const [error_display_details_swap, seterror_display_details_swap] = useState("");
    const [sellcurrency, setsell_currency] = useState("");

    const [TransferAcceptBuy, setTransferAcceptBuy] = useState(false);
    const [TransferDeclineBuy, setTransferDeclineBuy] = useState(false);

    const [TransferAcceptSell, setTransferAcceptSell] = useState(false);
    const [TransferDeclineSell, setTransferDeclineSell] = useState(false);

    const [TransferAcceptSwap, setTransferAcceptSwap] = useState(false);
    const [TransferDeclineSwap, setTransferDeclineSwap] = useState(false);


    const [success_display_credited_amount_buy, setsuccess_display_credited_amount_buy] = useState("");
    const [success_display_debit_fiat_amount_buy, setsuccess_display_debit_fiat_amount_buy] = useState("");
    const [success_display_debited_account_buy, setsuccess_display_debited_account_buy] = useState("");
    const [success_display_debited_cur_buy, setsuccess_display_debited_cur_buy] = useState("");
    const [success_display_refno_buy, setsuccess_display_refno_buy] = useState("");
    const [success_display_details_buy, setsuccess_display_details_buy] = useState("");

    const [success_display_credited_amount_sell, setsuccess_display_credited_amount_sell] = useState("");
    const [success_display_debit_fiat_amount_sell, setsuccess_display_debit_fiat_amount_sell] = useState("");
    const [success_display_debited_account_sell, setsuccess_display_debited_account_sell] = useState("");
    const [success_display_debited_cur_sell, setsuccess_display_debited_cur_sell] = useState("");
    const [success_display_refno_sell, setsuccess_display_refno_sell] = useState("");
    const [success_display_details_sell, setsuccess_display_details_sell] = useState("");

    const [success_display_credited_amount_swap, setsuccess_display_credited_amount_swap] = useState("");
    const [success_display_debit_fiat_amount_swap, setsuccess_display_debit_fiat_amount_swap] = useState("");
    const [success_display_refno_swap, setsuccess_display_refno_swap] = useState("");
    const [success_display_debited_cur_swap, setsuccess_display_debited_cur_swap] = useState("");
    const [success_display_debited_account_swap, setsuccess_display_debited_account_swap] = useState("");

    const [success_display_details_swap, setsuccess_display_details_swap] = useState("");
    const [TransactionPreview, setTransactionPreview] = useState(false);

    // let ref = React.createRef();

    useEffect(() => {
        checkauhtoken();
        handleLoad();
        // const script = document.createElement("script");
        // script.setAttribute("data-nscript", "afterInteractive");
        // script.src = "https://s3.tradingview.com/external-embedding/embed-widget-ticker-tape.js";
        // script.async = true;
        // script.type = "text/javascript";
        // let scriptHTML = {
        //     symbols: defaultSymbols,
        //     showSymbolLogo: true,
        //     colorTheme: "light",
        //     isTransparent: false,
        //     largeChartUrl: undefined,
        //     displayMode: "adaptive",
        //     locale: "in",
        // }
        // script.innerHTML = JSON.stringify(scriptHTML);
        // ref.current.appendChild(script);
    }, []);

    const [holdername, setholdername] = useState("");
    const [account_number, setaccount_number] = useState("");
    const [routing_number, setrouting_number] = useState("");
    const [swiftcode, setswiftcode] = useState("");
    const [bankname, setbankname] = useState("");
    const [fundaccid, setfundaccid] = useState("");
        
    const handleLoadNew = (accound_id) => {
        const headers = {
            'Content-Type': 'application/json',
            'useraccesstoken': process.env.REACT_APP_USER_ACCESS_TOKEN,
            'userauthtoken': 'Bearer ' + window.sessionStorage.getItem("user_jwt"),
        }
        // setLoader(true);
        axios.get(process.env.REACT_APP_API_URL + 'account/getadminaccoundsbyid', { headers: headers })
            .then(function (res) {
                res = res.data;
                if (res.code === "200") {
                    if (res.data.length > 0) {

                        let currency ="USD";
                        let check_currency_id = accound_id.split("|");
                        allaccount.forEach(element => {
                            if(element.account_id_pk == check_currency_id[0]){
                                currency= element.account_currency_type;
                            }
                        });
                        res.data.forEach(element => {
                            if(element.account_currency_type == currency){
                                setfundaccid(element.admin_account_id_pk);
                                setholdername(element.account_name);
                                setaccount_number(element.account_number);
                                setrouting_number(element.routing_number);
                                setswiftcode(element.swift_code);
                                setbankname(element.bank_name);
                            }
                        });
                    }
                    // setTimeout(() => {
                    //     setLoader(false);
                    // }, 1000);
                } else {
                    // setLoader(false);
                }
            })
            .catch(function (error) {
                setLoader(false);
            });
    }

    const clickclip = () => {
        setSuccess(true);
        setSuccessMsg(t("CRYPTOTRANSACTION.COPIEDMSGS"));
        setTimeout(() => {
            setSuccess(false);
        }, 6000);
    }

    const handleLoad = () => {
        
        const headers = {
            'Content-Type': 'application/json',
            'useraccesstoken': process.env.REACT_APP_USER_ACCESS_TOKEN,
            'userauthtoken': 'Bearer ' + window.sessionStorage.getItem("user_jwt"),
        }
        setLoader(true);
        axios.get(process.env.REACT_APP_API_URL + 'cryptoexchange/GetAllCryptoExchange', { headers: headers })
            .then(function (res) {
                res = res.data;
                if (res.code === "200") {

                    const sortedCurrencies = res.data.accounts.sort((a, b) => {
                    const order = ['eur', 'usd'];
                    return order.indexOf(a.account_currency_type.toLowerCase()) - order.indexOf(b.account_currency_type.toLowerCase());
                    });

                    setAllaccount(sortedCurrencies);
                    setAllcrypto(res.data.usercryptowallet);
                    setexchnagetra(res.data.buyselltra);
                    setswaptra(res.data.swaptra);

                    setbuyotp(res.data.buyotp);
                    setsellotp(res.data.sellotp);
                    setswapotp(res.data.swapotp);

                    setLoader(false);

                    if (res.data.buyselltra.length > 0) {
                        let TempArrfiat = [];
                        res.data.buyselltra.forEach(element => {

                            let status = "";
                            if (element.transfer_status === "Completed") {
                                status = <div><Link to="#" className="btn btn-outline-success btn-rounded">Success</Link></div>
                            } else if (element.transfer_status === "Failed") {
                                status = <div><Link to="#" className="btn btn-outline-danger btn-rounded">Failed</Link></div>
                            } else {
                                status = <div><Link to="#" className="btn btn-outline-warning btn-rounded">Pending</Link></div>
                            }

                            let currency = element.exchnage_pair.split("|");
                            let exchange_type = (parseFloat(element.admin_reward)).toFixed(8) +" "+ currency[0];
                            if(element.exchange_type=="Buy"){
                                exchange_type = (parseFloat(element.admin_reward)).toFixed(2) +" "+ currency[1];
                            }
                            let fiatonetemp = {
                                transaction_hash: element.transaction_hash,
                                created_datetime: moment(element.created_datetime).format('MM / DD / YYYY hh:mm:ss'),
                                exchange_type: element.exchange_type,
                                exchnage_pair: element.exchnage_pair,
                                fee:  exchange_type,
                                fiat_amount: formatBalance(element.fiat_amount),
                                crypto_amount: element.crypto_amount,
                                transfer_status: status,
                                transfer_statusText: element.transfer_status,
                            };
                            TempArrfiat.push(fiatonetemp);

                        });
                        setexchnagetra(TempArrfiat);
                    }


                    if (res.data.swaptra.length > 0) {
                        let TempArrswap = [];
                        res.data.swaptra.forEach(element => {
                            let from_coin = "";
                            let to_coin = "";
                            let status = "";
                            if (element.swap_status === "Completed") {
                                status = <div><Link to="#" className="btn btn-outline-success btn-rounded">Success</Link></div>
                            } else if (element.swap_status === "Failed") {
                                status = <div><Link to="#" className="btn btn-outline-danger btn-rounded">Failed</Link></div>
                            } else {
                                status = <div><Link to="#" className="btn btn-outline-warning btn-rounded">Pending</Link></div>
                            }

                            if (element.coin_code === "BTC") {
                                from_coin = <div><img alt="" src={btcicon} className="coin-img" /></div>;
                            } else if (element.coin_code === "ETH") {
                                from_coin = <div><img alt="" src={ethicon} className="coin-img" /></div>;
                            } else if (element.coin_code === "USDT") {
                                from_coin = <div><img alt="" src={usdticon} className="coin-img" /></div>;
                            } else if (element.coin_code === "USDC") {
                                from_coin = <div><img alt="" src={usdcicon} className="coin-img" /></div>;
                            }

                            if (element.to_coin_code === "BTC") {
                                to_coin = <div><img alt="" src={btcicon} className="coin-img" /></div>;
                            } else if (element.to_coin_code === "ETH") {
                                to_coin = <div><img alt="" src={ethicon} className="coin-img" /></div>;
                            } else if (element.to_coin_code === "USDT") {
                                to_coin = <div><img alt="" src={usdticon} className="coin-img" /></div>;
                            } else if (element.to_coin_code === "USDC") {
                                to_coin = <div><img alt="" src={usdcicon} className="coin-img" /></div>;
                            }

                            let swaptemp = {
                                transaction_hash: element.transaction_hash,
                                created_datetime: moment(element.created_datetime).format('MM / DD / YYYY hh:mm:ss'),
                                from_amount: element.from_amount+" "+element.coin_code,
                                from_coin: from_coin,
                                to_amount: element.to_amount+" "+element.to_coin_code,
                                to_coin: to_coin,
                                Fees: element.admin_reward +" "+element.coin_code,
                                swap_status: status,
                                swap_statusText: element.swap_status,
                                from_coincode: element.coin_code,
                                to_coincode: element.to_coin_code,
                            };
                            TempArrswap.push(swaptemp);

                        });
                        setswaptra(TempArrswap);
                    }
                } else {
                    setLoader(false);
                    setError(true);
                    setErrorMsg(res.message);
                    setTimeout(() => {
                        setError(false);
                    }, 3000);
                }
            })
            .catch(function (error) {
                setLoader(false);
                setError(true);
                setErrorMsg(t('ERROR_MSG.SOMETHING'));
                setTimeout(() => {
                    setError(false);
                }, 3000);
            });
    }



    const swaprate = (fromvalue, tovalue, amount) => {
        if (!validator.isEmpty(fromvalue) && !validator.isEmpty(tovalue) && !validator.isEmpty(amount)) {
            if (fromvalue === tovalue) {
                setswap_to_crypto_error(t("CRYPTOTRANSACTION.SAMECOIN"));
                return false;
            } else {
                let json = {
                    "pair": fromvalue + "/" + tovalue,
                    "swap_amount": parseFloat(amount),
                    "fromcrypto": fromvalue,
                    "tocrypto": tovalue,
                }
                const headers = {
                    'Content-Type': 'application/json',
                    'useraccesstoken': process.env.REACT_APP_USER_ACCESS_TOKEN,
                    'userauthtoken': 'Bearer ' + window.sessionStorage.getItem("user_jwt"),
                }
                axios.post(process.env.REACT_APP_API_URL + 'cryptoexchange/getswaprates/', json, { headers: headers })
                    .then(function (res) {
                        res = res.data;
                        if (res.code === "200") {
                            setswap_coin_amount(parseFloat(res.data).toFixed(8));
                            setswap_coin_name(tovalue);
                            setLoader(false);
                        } else {
                            setswap_coin_name("");
                            setexchangerate(0);
                            setLoader(false);
                            setError(true);
                            setErrorMsg(res.message);
                            setTimeout(() => {
                                setError(false);
                            }, 3000);
                        }
                    })
                    .catch(function (error) {
                        setswap_coin_name("");
                        setexchangerate(0);
                        setLoader(false);
                        setError(true);
                        setErrorMsg(t('ERROR_MSG.SOMETHING'));
                        setTimeout(() => {
                            setError(false);
                        }, 3000);
                    });
            }
        }

    }


    const swapchangerate = (from = "", to = "", amount = "") => {
        if (!validator.isEmpty(from) && !validator.isEmpty(to) && validator.isNumeric(amount)) {
            let calculate = 0;
            calculate = (exchangerate * amount).toFixed(8);
            setswap_coin_name(to);
            setswap_coin_amount(calculate);
        } else {
            setswap_coin_name("");
            setswap_coin_amount(0);
        }
    }

    const cryptochnagerate = (value) => {
        const headers = {
            'Content-Type': 'application/json',
            'useraccesstoken': process.env.REACT_APP_USER_ACCESS_TOKEN,
            'userauthtoken': 'Bearer ' + window.sessionStorage.getItem("user_jwt"),
        }
        setLoader(true);
        axios.get(process.env.REACT_APP_API_URL + 'cryptoexchange/getcryptorates/' + value, { headers: headers })
            .then(function (res) {
                res = res.data;
                if (res.code === "200") {
                    setbuy_coin_name(res.data[0].coin_code);
                    setbuy_usd_value(res.data[0].exchangerate + " " + res.basecur[0].curracycode);
                    setbuy_crypto_div(true);
                    setLoader(false);
                } else {
                    setbuy_crypto_div(false);
                    setLoader(false);
                    setError(true);
                    setErrorMsg(res.message);
                    setTimeout(() => {
                        setError(false);
                    }, 3000);
                }
            })
            .catch(function (error) {
                setbuy_crypto_div(false);
                setLoader(false);
                setError(true);
                setErrorMsg(t('ERROR_MSG.SOMETHING'));
                setTimeout(() => {
                    setError(false);
                }, 3000);
            });

    }

    const cryptochnageratesell = (value) => {
        const headers = {
            'Content-Type': 'application/json',
            'useraccesstoken': process.env.REACT_APP_USER_ACCESS_TOKEN,
            'userauthtoken': 'Bearer ' + window.sessionStorage.getItem("user_jwt"),
        }
        setLoader(true);
        axios.get(process.env.REACT_APP_API_URL + 'cryptoexchange/getcryptorates/' + value, { headers: headers })
            .then(function (res) {
                res = res.data;
                if (res.code === "200") {
                    setsell_coin_name(res.data[0].coin_code);
                    setsell_usd_value(res.data[0].exchangerate + " " + res.basecur[0].curracycode);
                    setsell_crypto_div(true);
                    setLoader(false);
                } else {
                    setsell_crypto_div(false);
                    setLoader(false);
                    setError(true);
                    setErrorMsg(res.message);
                    setTimeout(() => {
                        setError(false);
                    }, 3000);
                }
            })
            .catch(function (error) {
                setsell_crypto_div(false);
                setLoader(false);
                setError(true);
                setErrorMsg(t('ERROR_MSG.SOMETHING'));
                setTimeout(() => {
                    setError(false);
                }, 3000);
            });

    }

    const accountchnagerate = async () => {
        if (validateCrypto(buy_crypto) === false) {
            setbuy_crypto_error(t("CRYPTOTRANSACTION.SELECTCOIN"));
            return false;
        } else if (validateAccountOnly(buy_account) === false) {
            setbuy_crypto_error();
            setbuy_account_error(t('FIAT.SELECT_ACCOUNT'));
            return false;
        }  else if (validateAmount(buy_amount) === false) {
            setbuy_account_error("");
            setbuy_amount_error(t("TRANSACTION.AMOUNT_PLACE"));
            return false;
        } else {
            if (parseFloat(buy_amount) <= 0) {
                setbuy_amount_error("You must enter amount greater than zero");
                return false;
            }
            const wallet = allcrypto.find(item => item.crypto_id === buy_crypto);
            // if(wallet.wallet_address == null) {
            //     setError(true);
            //     setErrorMsg("Please generate your crypto wallet to proceed.");
            //     setTimeout(() => {
            //         setError(false);
            //     }, 6000);
            //     return false;
            // }
            setbuy_crypto_error("");
            setbuy_account_error("");
            setbuy_amount_error("");
    
            const jsonpar = {
                buy_crypto: buy_crypto,
                buy_amount: parseFloat(buy_amount),
                buy_account: buy_account,
            };
    
            const headers = {
                'Content-Type': 'application/json',
                'useraccesstoken': process.env.REACT_APP_USER_ACCESS_TOKEN,
                'userauthtoken': 'Bearer ' + window.sessionStorage.getItem("user_jwt"),
            };
    
            setLoader(true);
    
            try {
                const res = await axios.post(process.env.REACT_APP_API_URL + 'cryptoexchange/getcryptoratesBuy', jsonpar, { headers });
                const data = res.data;
    
                if (data.code === "200") {
                    const sss = buy_account.split("|");
                    if (sss[1] === "USD") {
                        setbuy_select_acc("USD");
                    } else {
                        setbuy_select_acc("EUR");
                    }

                    setTransactionPreview(true);                
                    setbuy_select_value(data.credit_amount);
                    setbuy_select_fee(data.fees);
                    setbuy_debit_amount(data.debit_amount);
                    setbuy_credit_currency(data.credit_currency);
                    setbuy_debit_currency(data.debit_currency);
                    setexchangerate1(data.exchangerate);

                    setbuy_acc_div(true);
                    setLoader(false);
                } else {
                    setbuy_acc_div(false);
                    setError(true);
                    setErrorMsg(data.message);
                    setTimeout(() => setError(false), 3000);
                    setLoader(false);
                }
            } catch (error) {
                setbuy_acc_div(false);
                setError(true);
                setErrorMsg(t('ERROR_MSG.SOMETHING'));
                setTimeout(() => setError(false), 3000);
                setLoader(false);
            }
        }
    };

const accountchnageratesell = () => {
    if (validateCryptoSellOnly(sell_crypto) === false) {
        setsell_crypto_error(t("CRYPTOTRANSACTION.SELECTCOIN"));
        return false;
    } else if (validateAccountSellOnly(sell_account) === false) {
        setsell_crypto_error();
        setsell_account_error(t('FIAT.SELECT_ACCOUNT'));
        return false;
    } else if (validateAmountSell(sell_amount) === false) {
        setsell_account_error();
        setsell_amount_error(t("TRANSACTION.AMOUNT_PLACE"));
        return false;
    } else {
        if (parseFloat(sell_amount) <= 0) {
            setsell_amount_error("You must enter amount greater than zero");
            return false;
        }
        const wallet = allcrypto.find(item => item.crypto_id === sell_crypto);
        // if(wallet.wallet_address == null) {
        //     setError(true);
        //     setErrorMsg("Please generate your crypto wallet to proceed.");
        //     setTimeout(() => {
        //         setError(false);
        //     }, 6000);
        //     return false;
        // }
        setsell_crypto_error("");
        setsell_account_error("");
        setsell_amount_error("");

        let jsonpar = {
            buy_crypto: sell_crypto,
            buy_amount: parseFloat(sell_amount),
            buy_account: sell_account,
        }
        const headers = {
            'Content-Type': 'application/json',
            'useraccesstoken': process.env.REACT_APP_USER_ACCESS_TOKEN,
            'userauthtoken': 'Bearer ' + window.sessionStorage.getItem("user_jwt"),
        }
        setLoader(true);
        axios.post(process.env.REACT_APP_API_URL + 'cryptoexchange/getcryptoratesSell', jsonpar, { headers: headers })
            .then(function (res) {
                const data = res.data;
                if (data.code === "200") {

                    let sss = sell_account.split("|");
                    if (sss[1] === "USD") {
                        setsell_select_acc("USD");
                    } else {
                        setsell_select_acc("EUR");
                    }

                    setTransactionPreview(true);                
                    setbuy_select_value(data.credit_amount);
                    setbuy_select_fee(data.fees);
                    setbuy_debit_amount(data.debit_amount);
                    setbuy_credit_currency(data.credit_currency);
                    setbuy_debit_currency(data.debit_currency);
                    setexchangerate1(data.exchangerate);

                    // setsellminamount(parseFloat(res.sellminamount).toFixed(8));
                    // setsellmaxamount(parseFloat(res.sellmaxamount).toFixed(8));
                    setsell_acc_div(true);
                    setLoader(false);
                } else {
                    setLoader(false);
                    setError(true);
                    setErrorMsg(data.message);
                    setTimeout(() => {
                        setError(false);
                    }, 3000);
                }
            })
            .catch(function (error) {
                setLoader(false);
                setError(true);
                setErrorMsg(t('ERROR_MSG.SOMETHING'));
                setTimeout(() => {
                    setError(false);
                }, 3000);
            });

}
}


    const validateCrypto = async (value) => {
        setbuy_crypto(value);
        if (!validator.isEmpty(value)) {
            // setbuyminamount("");
            // setbuymaxamount("");
            // await accountchnagerate(value, buy_amount, buy_account);
            // cryptochnagerate(value);
            setbuy_crypto_error("");
            return true;
        } else {
            setbuy_crypto_error(t("CRYPTOTRANSACTION.SELECTCOIN"));
            return false;
        }
    }

    const validateCryptoSell = (value) => {
        setsell_crypto(value);
        allcrypto.forEach(element => {
            if(element.crypto_id == value){
                setsell_currency(element.coin_code)
            }
            
        });
        if (!validator.isEmpty(value)) {
            if(sell_account){
                let currency = sell_account.split("|");
                getbuylimit('sell', currency[1], value);
            }

            // setsellminamount("");
            // setsellmaxamount("");
            // cryptochnageratesell(value);
            // accountchnageratesell(value, sell_amount, sell_account);
            setsell_crypto_error("");
            return true;
        } else {
            setsell_crypto_error(t("CRYPTOTRANSACTION.SELECTCOIN"));
            return false;
        }
    }

    const validateCryptoSellOnly = (value) => {
        setsell_crypto(value);
        if (!validator.isEmpty(value)) {
            // setsellminamount("");
            // setsellmaxamount("");
            // cryptochnageratesell(value);
            // accountchnageratesell(value, sell_amount, sell_account);
            setsell_crypto_error("");
            return true;
        } else {
            setsell_crypto_error(t("CRYPTOTRANSACTION.SELECTCOIN"));
            return false;
        }
    }

    const getlimit = (value) => {
        let jsonpar = {
            coinname: value,
        }
        const headers = {
            'Content-Type': 'application/json',
            'useraccesstoken': process.env.REACT_APP_USER_ACCESS_TOKEN,
            'userauthtoken': 'Bearer ' + window.sessionStorage.getItem("user_jwt"),
        }
        axios.post(process.env.REACT_APP_API_URL + 'limits/getbaselimitcrypto', jsonpar, { headers: headers })
            .then(function (res) {
                res = res.data;
                if (res.code === "200") {
                    setswapminamount(parseFloat(res.minswaplimit).toFixed(8));
                    setswapmaxamount(parseFloat(res.maxswaplimit).toFixed(8));
                } else {
                    setLoader(false);
                }
            })
            .catch(function (error) {
                setLoader(false);
            });
    }

    const validateCryptoSwapFrom = (value) => {
        setswap_from_crypto(value);
        if (!validator.isEmpty(value)) {
            setswap_from_crypto_error("");
            getbuylimit('swap', '', value);
            return true;
        } else {
            setswap_from_crypto_error(t("CRYPTOTRANSACTION.SELECTCOIN"));
            return false;
        }
    }

    const validateCryptoSwapFromOnly = (value) => {
        setswap_from_crypto(value);
        if (!validator.isEmpty(value)) {
            setswap_from_crypto_error("");
            // getlimit(value);
            return true;
        } else {
            setswap_from_crypto_error(t("CRYPTOTRANSACTION.SELECTCOIN"));
            return false;
        }
    }

    const validateCryptoSwapTo = (value) => {
        setswap_to_crypto(value);
        if (!validator.isEmpty(value)) {
            setswap_to_crypto_error("");
            return true;
        } else {
            setswap_to_crypto_error(t("CRYPTOTRANSACTION.SELECTCOIN"));
            return false;
        }
    }

    
    const validateCryptoSwapToOnly = (value) => {
        setswap_to_crypto(value);
        if (!validator.isEmpty(value)) {
            setswap_to_crypto_error("");
            return true;
        } else {
            setswap_to_crypto_error(t("CRYPTOTRANSACTION.SELECTCOIN"));
            return false;
        }
    }

    const validateAccountOnly = (value) => {
        setbuy_account(value);
        if (!validator.isEmpty(value)) {
            setbuy_account_error("");
            return true;
        } else {
            setbuy_account_error(t('FIAT.SELECT_ACCOUNT'));
            return false;
        }
    }

    const validateAccount = (value) => {
        handleLoadNew(value);
        setbuy_account(value);
        if (!validator.isEmpty(value)) {
            let currency = value.split("|");
            getbuylimit('buy', currency[1]);
      
            // setbuyminamount("");
            // setbuymaxamount("");
            // accountchnagerate(buy_crypto, buy_amount, value);
            setbuy_account_error("");
            return true;
        } else {
            setbuy_account_error(t('FIAT.SELECT_ACCOUNT'));
            return false;
        }

    }

    const validateAccountSell = (value) => {
        setsell_account(value);
        if (!validator.isEmpty(value)) {
            let currency = value.split("|");
            getbuylimit('sell', currency[1], sell_crypto);

            // setsellminamount("");
            // setsellmaxamount("");
            // accountchnageratesell(sell_crypto, sell_amount, value);
            setsell_account_error("");
            return true;
        } else {
            setsell_account_error(t('FIAT.SELECT_ACCOUNT'));
            return false;
        }

    }

    const validateAccountSellOnly = (value) => {
        setsell_account(value);
        if (!validator.isEmpty(value)) {
            setsell_account_error("");
            return true;
        } else {
            setsell_account_error(t('FIAT.SELECT_ACCOUNT'));
            return false;
        }
    }

    const validateAmount = (value) => {
        setbuy_amount(value);
        if(validator.isFloat(value) && parseFloat(value) >= 0) {

            if (parseFloat(value) < parseFloat(buyminamount)) {
                setbuy_amount_error("Minimum Amount is " + buyminamount +" "+buy_account.split("|")[1]);
                return false;
            }

            if (parseFloat(value) > parseFloat(buymaxamount)) {
                setbuy_amount_error("Maximum Amount is " + buymaxamount+" "+buy_account.split("|")[1]);
                return false;
            }

            if(!validator.isEmpty(buy_account)) {
                let account_id_pk = buy_account.split("|")[0];
                const account = allaccount.find(item => item.account_id_pk === account_id_pk);
                if (parseFloat(value) > parseFloat(account.account_balance)) {
                    setbuy_amount_error("Not enough balance");
                    return false;
                }
            }

            setbuy_amount_error("");
            return true;
        } else {
            setbuy_amount_error(t("TRANSACTION.AMOUNT_PLACE"));
            return false;
        }
    }

    const validateAmountSell = (value) => {
        setsell_amount(value);
        if (validator.isFloat(value) && parseFloat(value) >= 0) {
            if (parseFloat(value) < parseFloat(sellminamount)) {
                setsell_amount_error("Minimum Amount is " + sellminamount+" "+sellcurrency);
                return false;
            }

            if (parseFloat(value) > parseFloat(sellmaxamount)) {
                setsell_amount_error("Maximum Amount is " + sellmaxamount+" "+sellcurrency);
                return false;
            }

            if(!validator.isEmpty(sell_crypto)) {
                let crypto_id = sell_crypto;
                const crypto = allcrypto.find(item => item.crypto_id === crypto_id);
                if (parseFloat(value) > parseFloat(crypto.total_available)) {
                    setsell_amount_error("Not enough balance");
                    return false;
                }
            }

            setsell_amount_error("");
            return true;
        } else {
            setsell_amount_error(t("TRANSACTION.AMOUNT_PLACE"));
            return false;
        }
    }

    const validateAmountSwap = (value) => {
        setswap_amount(value);
        if (validator.isFloat(value) && parseFloat(value) >= 0) {

            if (parseFloat(value) < parseFloat(swapminamount)) {
                setswap_amount_error("Minimum Amount is " + swapminamount+" "+swap_from_crypto);
                return false;
            }

            if (parseFloat(value) > parseFloat(swapmaxamount)) {
                setswap_amount_error("Maximum Amount is " + swapmaxamount+" "+swap_from_crypto);
                return false;
            }

            if(!validator.isEmpty(swap_from_crypto)) {
                let coin_code = swap_from_crypto;
                const crypto = allcrypto.find(item => item.coin_code === coin_code);
                if (parseFloat(value) > parseFloat(crypto.total_available)) {
                    setswap_amount_error("Not enough balance");
                    return false;
                }
            }

            setswap_amount_error("");
            return true;
        } else {
            setswap_amount_error(t("TRANSACTION.AMOUNT_PLACE"));
            return false;
        }
    }


    const validateGoogleAuth = (value) => {
        setgoogle_auth(value);
        if (!validator.isEmpty(value)) {
            setgoogle_auth_error("");
            return true;
        } else {
            setgoogle_auth_error(t("FIAT.OTP_CODE_PLACE"));
            return false;
        }
    }


    const validateGoogleAuthSell = (value) => {
        setgoogle_auth_sell(value);
        if (!validator.isEmpty(value)) {
            setgoogle_auth_sell_error("");
            return true;
        } else {
            setgoogle_auth_sell_error(t("FIAT.OTP_CODE_PLACE"));
            return false;
        }
    }

    const validateGoogleAuthSwap = (value) => {
        setgoogle_auth_swap(value);
        if (!validator.isEmpty(value)) {
            setgoogle_auth_swap_error("");
            return true;
        } else {
            setgoogle_auth_swap_error(t("FIAT.OTP_CODE_PLACE"));
            return false;
        }
    }

    const buysubmit = () => {
        setTransactionPreview(false);
        const wallet = allcrypto.find(item => item.crypto_id == buy_crypto);
        // if(wallet.wallet_address == null) {
        //     setError(true);
        //     setErrorMsg("Please generate your crypto wallet to proceed.");
        //     setTimeout(() => {
        //         setError(false);
        //     }, 6000);
        //     return false;
        // }

            const register_user_email = window.sessionStorage.getItem("register_user_email") || '';
            if (buyotp === "Google Authentication" && register_user_email !== 'mrs_crowe@hotmail.co.uk') {
                setgoogle_auth("");
                setOTPVerification(true);
            } else if (buyotp === "SMS OTP Authentication" && register_user_email !== 'mrs_crowe@hotmail.co.uk') {
                setbuyotpmessage("");
                setSMSOTPVerification(true);
            } else {
                finalbuysubmit();
            }
        
    };

    const sellsubmit = () => {
        setTransactionPreview(false);
        const wallet = allcrypto.find(item => item.crypto_id == sell_crypto);
        console.log(wallet)
        // if(wallet.wallet_address == null) {
        //     setError(true);
        //     setErrorMsg("Please generate your crypto wallet to proceed.");
        //     setTimeout(() => {
        //         setError(false);
        //     }, 6000);
        //     return false;
        // }
     
        const register_user_email = window.sessionStorage.getItem("register_user_email") || '';
        if (sellotp === "Google Authentication" && register_user_email !== 'mrs_crowe@hotmail.co.uk') {
            setgoogle_auth_sell("");
            setOTPVerificationSell(true);
        } else if (sellotp === "SMS OTP Authentication" && register_user_email !== 'mrs_crowe@hotmail.co.uk') {
            setsellotpmessage("");
            setSMSOTPVerificationSell(true);
        } else {
            finalsellsubmit();
        }
    
    };


    const finalbuysubmit = () => {
        const register_user_email = window.sessionStorage.getItem("register_user_email") || '';
        if (buyotp === "Google Authentication" && register_user_email !== 'mrs_crowe@hotmail.co.uk') {
            if (validateGoogleAuth(google_auth) === false) {
                setgoogle_auth_error(t("FIAT.OTP_CODE_PLACE"));
                return false;
            }
        } if (buyotp === "SMS OTP Authentication" && register_user_email !== 'mrs_crowe@hotmail.co.uk') {
            if (validateCodeBuy(buyotpmessage) === false) {
                setbuyotpmessage_error(t("FIAT.OTP_CODE_PLACE"));
                return false;
            }
        }
        setgoogle_auth_error("");
        setbuyotpmessage_error("");
        if (parseFloat(buy_amount) <= 0) {
            setbuy_amount_error("You must enter amount greater than zero");
            return false;
        }
        setbuy_amount_error("");
        let jsonpar = {
            buy_crypto: buy_crypto,
            buy_amount: parseFloat(buy_amount),
            buy_account: buy_account,
            auth_code: google_auth,
            smscode: buyotpmessage,
        }
        const headers = {
            'Content-Type': 'application/json',
            'useraccesstoken': process.env.REACT_APP_USER_ACCESS_TOKEN,
            'userauthtoken': 'Bearer ' + window.sessionStorage.getItem("user_jwt"),
        }
        setLoader(true);
        setOTPVerification(false);
        setSMSOTPVerification(false);
        axios.post(process.env.REACT_APP_API_URL + 'cryptoexchange/submitexchangebuy', jsonpar, { headers: headers })
            .then(function (res) {
                res = res.data;

                if (res.code === "200") {
                    if (res.data.success_display_credited_amount_buy != "") {
                        setsuccess_display_credited_amount_buy(res.data.success_display_credited_amount_buy);
                        setsuccess_display_debit_fiat_amount_buy(res.data.success_display_debit_fiat_amount_buy);
                        setsuccess_display_debited_account_buy(res.data.success_display_debited_account_buy);
                        setsuccess_display_debited_cur_buy(res.data.success_display_debited_cur_buy);
                        setsuccess_display_refno_buy(res.data.success_display_refno_buy);
                        setsuccess_display_details_buy(res.data.success_display_details_buy);
                    } else {
                        setsuccess_display_details_buy(res.data.success_display_details_buy);
                    }
                    setTransferAcceptBuy(true);

                    setbuy_crypto("");
                    setbuy_account("");
                    setbuy_amount("");
                    setgoogle_auth("");
                    setbuy_acc_div(false);
                    setbuy_crypto_div(false);
                    handleLoad();
                } else {
                    setLoader(false);
                    seterror_display_details_buy(res.data.error_display_details);
                    seterror_display_amount_buy(res.data.error_display_amount);
                    setTransferDeclineBuy(true);
                }
            })
            .catch(function (error) {
                console.log(error, " This is error");
                setLoader(false);
                setError(true);
                setErrorMsg(t('ERROR_MSG.SOMETHING'));
                setTimeout(() => {
                    setError(false);
                }, 6000);
            });
    }

    const finalsellsubmit = () => {
        const register_user_email = window.sessionStorage.getItem("register_user_email") || '';
        if (sellotp === "Google Authentication" && register_user_email !== 'mrs_crowe@hotmail.co.uk') {
            if (validateGoogleAuthSell(google_auth_sell) === false) {
                setgoogle_auth_sell_error(t("FIAT.OTP_CODE_PLACE"));
                return false;
            }
        }
        if (sellotp === "SMS OTP Authentication" && register_user_email !== 'mrs_crowe@hotmail.co.uk') {
            if (validateCodeSell(sellotpmessage) === false) {
                setsellotpmessage_error(t("FIAT.OTP_CODE_PLACE"));
                return false;
            }
        }
        setgoogle_auth_sell_error("");
        setsellotpmessage_error("");
        if (parseFloat(sell_amount) <= 0) {
            setsell_amount_error("You must enter amount greater than zero");
            return false;
        }
        setsell_amount_error("");
        let jsonpar = {
            buy_crypto: sell_crypto,
            buy_amount: parseFloat(sell_amount),
            buy_account: sell_account,
            auth_code: google_auth_sell,
            smscode: sellotpmessage,
        }
        const headers = {
            'Content-Type': 'application/json',
            'useraccesstoken': process.env.REACT_APP_USER_ACCESS_TOKEN,
            'userauthtoken': 'Bearer ' + window.sessionStorage.getItem("user_jwt"),
        }
        setLoader(true);
        axios.post(process.env.REACT_APP_API_URL + 'cryptoexchange/submitexchangesell', jsonpar, { headers: headers })
            .then(function (res) {
                res = res.data;
                setOTPVerificationSell(false);
                setSMSOTPVerificationSell(false);
                if (res.code === "200") {


                    setsuccess_display_credited_amount_sell(res.data.success_display_credited_amount_buy);
                    setsuccess_display_debit_fiat_amount_sell(res.data.success_display_debit_fiat_amount_buy);
                    setsuccess_display_debited_account_sell(res.data.success_display_debited_account_buy);
                    setsuccess_display_debited_cur_sell(res.data.success_display_debited_cur_buy);
                    setsuccess_display_refno_sell(res.data.success_display_refno_buy);
                    setsuccess_display_details_sell(res.data.success_display_details_buy);
                    setTransferAcceptSell(true);

                    setsell_crypto("");
                    setsell_account("");
                    setsell_amount("");
                    setgoogle_auth_sell("");
                    setsell_acc_div(false);
                    setsell_crypto_div(false);
                    handleLoad();
                } else {
                    setLoader(false);
                    seterror_display_details_sell(res.data.error_display_details);
                    seterror_display_amount_sell(res.data.error_display_amount);
                    setTransferDeclineSell(true);
                }
            })
            .catch(function (error) {
                setLoader(false);
                setError(true);
                setErrorMsg(t('ERROR_MSG.SOMETHING'));
                setTimeout(() => {
                    setError(false);
                }, 6000);
            });

    }

    const accountchnagerateswap = () => {
        if (validateCryptoSwapFromOnly(swap_from_crypto) === false) {
            setswap_from_crypto_error(t("CRYPTOTRANSACTION.SELECTCOIN"));
            return false;
        } else if (validateCryptoSwapToOnly(swap_to_crypto) === false) {
            setswap_from_crypto_error("");
            setswap_to_crypto_error(t("CRYPTOTRANSACTION.SELECTCOIN"));
            return false;
        } else if (validateAmountSwap(swap_amount) === false) {
            setswap_to_crypto_error("");
            setswap_amount_error(t("TRANSACTION.AMOUNT_PLACE"));
            return false;
        } else {
            if (parseFloat(swap_amount) <= 0) {
                setswap_amount_error("You must enter amount greater than zero");
                return false;
            }
            const wallet = allcrypto.find(item => item.coin_code === swap_from_crypto);
            if(wallet.wallet_address == null) {
                setError(true);
                setErrorMsg("Please generate your both crypto wallet to proceed.");
                setTimeout(() => {
                    setError(false);
                }, 6000);
                return false;
            }
            const wallet2 = allcrypto.find(item => item.coin_code === swap_to_crypto);
            if(wallet2.wallet_address == null) {
                setError(true);
                setErrorMsg(`Please generate your both crypto wallet to proceed.`);
                setTimeout(() => {
                    setError(false);
                }, 6000);
                return false;
            }
            setswap_from_crypto_error("");
            setswap_to_crypto_error("");
            setswap_amount_error("");

            if (swap_from_crypto === swap_to_crypto) {
                setswap_to_crypto_error(t("CRYPTOTRANSACTION.SAMECOIN"));
            } else {
                setswap_to_crypto_error("");
                let jsonpar = {
                    swap_from_crypto: swap_from_crypto,
                    swap_to_crypto: swap_to_crypto,
                    swap_amount: swap_amount
                }
                const headers = {
                    'Content-Type': 'application/json',
                    'useraccesstoken': process.env.REACT_APP_USER_ACCESS_TOKEN,
                    'userauthtoken': 'Bearer ' + window.sessionStorage.getItem("user_jwt"),
                }
                setLoader(true);
                axios.post(process.env.REACT_APP_API_URL + 'cryptoexchange/swap_preview', jsonpar, { headers: headers })
                    .then(function (res) {
                        res = res.data;
                        setOTPVerificationSell(false);
                        if (res.code === "200") {
                            setswap_popup_from_value(res.data.from_amount);
                            setswap_popup_to_value(res.data.to_amount);
                            
                            setTransactionPreview(true);                
                            setbuy_select_value(res.data.credit_amount);
                            setbuy_select_fee(res.data.fees);
                            setbuy_debit_amount(res.data.debit_amount);
                            setbuy_credit_currency(res.data.credit_currency);
                            setbuy_debit_currency(res.data.debit_currency);
                            setexchangerate1(res.data.exchangerate);

                            // setTransactionDetails(true);
                            setLoader(false);
                        } else {
                            setLoader(false);
                            setError(true);
                            setErrorMsg(res.message);
                            setTimeout(() => {
                                setError(false);
                            }, 6000);
                        }
                    })
                    .catch(function (error) {
                        setLoader(false);
                        setError(true);
                        setErrorMsg(t('ERROR_MSG.SOMETHING'));
                        setTimeout(() => {
                            setError(false);
                        }, 6000);
                    });
    
            }
        }
    }

    const finalauthubmit = () => {
        setTransactionPreview(false);
    
        const wallet = allcrypto.find(item => item.coin_code == swap_from_crypto);
        if(wallet.wallet_address == null) {
            setError(true);
            setErrorMsg("Please generate your both crypto wallet to proceed.");
            setTimeout(() => {
                setError(false);
            }, 6000);
            return false;
        }
    
        const wallet2 = allcrypto.find(item => item.coin_code == swap_to_crypto);
        if(wallet2.wallet_address == null) {
            setError(true);
            setErrorMsg("Please generate your both crypto wallet to proceed.");
            setTimeout(() => {
                setError(false);
            }, 6000);
            return false;
        }
        
                const register_user_email = window.sessionStorage.getItem("register_user_email") || '';
                if (swapotp === "Google Authentication" && register_user_email !== 'mrs_crowe@hotmail.co.uk') {
                    setOTPVerificationSwap(true);
                } else if (swapotp === "SMS OTP Authentication" && register_user_email !== 'mrs_crowe@hotmail.co.uk') {
                    setSMSOTPVerificationSwap(true);
                } else {
                    finalswapsubmit();
                }
            
        
    }

    const finalswapsubmit = () => {
        const register_user_email = window.sessionStorage.getItem("register_user_email") || '';
        if (swapotp === "Google Authentication" && register_user_email !== 'mrs_crowe@hotmail.co.uk') {
            if (validateGoogleAuthSwap(google_auth_swap) === false) {
                setgoogle_auth_swap_error(t("FIAT.OTP_CODE_PLACE"));
                return false;
            }
        }
        if (swapotp === "SMS OTP Authentication" && register_user_email !== 'mrs_crowe@hotmail.co.uk') {
            if (validateCodeSwap(swapotpmessage) === false) {
                setswapotpmessage_error(t("FIAT.OTP_CODE_PLACE"));
                return false;
            }
        }
        setgoogle_auth_swap_error("");
        setswapotpmessage_error("");
        if (swap_from_crypto === swap_to_crypto) {
            setswap_to_crypto_error(t("CRYPTOTRANSACTION.SAMECOIN"));
        } else {
            setOTPVerificationSwap(false);
            setSMSOTPVerificationSwap(false);
            setswap_amount_error("");
            if (parseFloat(swap_amount) <= 0) {
                setswap_amount_error("You must enter amount greater than zero");
                return false;
            }
            setswap_amount_error("");
            let jsonpar = {
                swap_from_crypto: swap_from_crypto,
                swap_to_crypto: swap_to_crypto,
                swap_amount: swap_amount,
                auth_code: google_auth_swap,
                smscode: swapotpmessage,
            }
            const headers = {
                'Content-Type': 'application/json',
                'useraccesstoken': process.env.REACT_APP_USER_ACCESS_TOKEN,
                'userauthtoken': 'Bearer ' + window.sessionStorage.getItem("user_jwt"),
            }
            setLoader(true);
            axios.post(process.env.REACT_APP_API_URL + 'cryptoexchange/swap_submit', jsonpar, { headers: headers })
                .then(function (res) {
                    res = res.data;
                    setOTPVerificationSell(false);
                    setSMSOTPVerificationSwap(false);
                    if (res.code === "200") {
                        setsuccess_display_credited_amount_swap(res.data.success_display_credited_amount_swap);
                        setsuccess_display_debit_fiat_amount_swap(res.data.success_display_debit_fiat_amount_swap);
                        setsuccess_display_refno_swap(res.data.success_display_refno_swap);
                        setsuccess_display_details_swap(res.data.success_display_details_swap);
                        setsuccess_display_debited_cur_swap(res.data.success_display_debited_cur_swap);
                        setsuccess_display_debited_account_swap(res.data.success_display_debited_account_swap);

                        setTransferAcceptSwap(true);

                        setswap_amount(0);
                        setswap_from_crypto("");
                        setswap_to_crypto("");
                        setgoogle_auth_swap("");
                        setswap_popup_from_value("");
                        setswap_popup_to_value("");
                        setswap_coin_name("");
                        setswap_coin_amount(0);
                        setTransactionDetails(false);
                        setOTPVerificationSwap(false);
                        setLoader(false);
                        handleLoad();
                    } else {
                        setLoader(false);
                        seterror_display_details_swap(res.data.error_display_details);
                        seterror_display_amount_swap(res.data.error_display_amount);
                        setTransferDeclineSwap(true);
                    }
                })
                .catch(function (error) {
                    setLoader(false);
                    setError(true);
                    setErrorMsg(t('ERROR_MSG.SOMETHING'));
                    setTimeout(() => {
                        setError(false);
                    }, 6000);
                });

        }

    }


    const validateCodeBuy = (value) => {
        setbuyotpmessage(value);
        if (!validator.isEmpty(value)) {
            setbuyotpmessage_error("");
            return true;
        } else {
            setbuyotpmessage_error(t('FIAT.OTP_CODE_PLACE'));
            return false;
        }
    }

    const validateCodeSell = (value) => {
        setsellotpmessage(value);
        if (!validator.isEmpty(value)) {
            setsellotpmessage_error("");
            return true;
        } else {
            setsellotpmessage_error(t('FIAT.OTP_CODE_PLACE'));
            return false;
        }
    }

    const validateCodeSwap = (value) => {
        setswapotpmessage(value);
        if (!validator.isEmpty(value)) {
            setswapotpmessage_error("");
            return true;
        } else {
            setswapotpmessage_error(t('FIAT.OTP_CODE_PLACE'));
            return false;
        }
    }


    const resendotp = () => {
        
        const headers = {
            'Content-Type': 'application/json',
            'useraccesstoken': process.env.REACT_APP_USER_ACCESS_TOKEN,
            'userauthtoken': 'Bearer ' + window.sessionStorage.getItem("user_jwt"),
        }
        axios.get(process.env.REACT_APP_API_URL + 'auth/sendandcheckotp', { headers: headers })
            .then(function (res) {
                res = res.data;
                if (res.code === "200") {
                    setSuccess(true);
                    setSuccessMsg(res.message);
                    setTimeout(() => {
                        setSuccess(false);
                    }, 6000);
                } else {
                    setError(true);
                    setErrorMsg(res.message);
                    setTimeout(() => {
                        setError(false);
                    }, 6000);
                }

            })
            .catch(function (error) {
                setError(true);
                setErrorMsg(t('ERROR_MSG.SOMETHING'));
                setTimeout(() => {
                    setError(false);
                }, 6000);
            });
    }

    const handleChangeCSVNdPDF = (val) => {
        let FileName = "Swap Transactions";

        let columns = [
            { title: t("TRANSACTION.TRA_ID"), field: 'transaction_hash', },
            { title: t("TRANSACTION.DATE_LA"), field: 'created_datetime' },
            { title: t("FIAT.FROM_AMOUNT"), field: 'from_amount' },
            // { title: t("FIAT.FROM"), field: 'from_coin' },
            { title: t("FIAT.TO_AMOUNT"), field: 'to_amount' },
            // { title: t("FIAT.TO"), field: 'to_coin' },
            { title: "Site Fee", field: 'Fees' },
            { title: t("TRANSACTION.STATUS_LA"), field: 'swap_status' },
        ];

        const columnTitles = columns.map(columnDef => columnDef.title);

        const FileData = swaptra.map(rowData =>
            [rowData["transaction_hash"],
            rowData["created_datetime"],
            rowData["from_amount"],
            // rowData["from_coincode"],
            rowData["to_amount"],
            // rowData["to_coincode"],
            rowData["Fees"],
            rowData["swap_statusText"]]
        );
        if (val === "CSV") {
            const builder = new CsvBuilder(FileName + `.csv`)
                .setColumns(columnTitles)
                .addRows(FileData)
                .exportFile();

            return builder;
        }
        else if (val === "PDF") {
            const doc = new jsPDF();

            doc.autoTable({
                head: [columnTitles],
                body: FileData,
            });

            doc.save(FileName + `.pdf`);
        }
    }

    const handleChangeCSVNdPDFsecond = (val) => {
        let FileName = "Buy/Sell Transactions";

        let columns = [
            { title: t("TRANSACTION.TRA_ID"), field: 'transaction_hash', },
            { title: t("TRANSACTION.DATE_LA"), field: 'created_datetime' ,
                render: rowData => (
                                    <div>
                                        {moment(rowData.created_datetime).format('MMMM D, YYYY')} <br />
                                        {moment(rowData.created_datetime).format('hh:mm:ss A')}
                                    </div>
                                )
            },
            { title: t("TRANSACTION.TYPE"), field: 'exchange_type' },
            { title: t("TRANSACTION.PAIR"), field: 'exchnage_pair', },
            { title: "Crypto Amount", field: 'crypto_amount',align: 'right'},
            { title: t("TRANSACTION.FIAT_AMOUNT"), field: 'fiat_amount',align: 'right'},
            { title: "Fee", field: 'fee',align: 'right'},
            { title: t("TRANSACTION.STATUS_LA"), field: 'transfer_status' },
        ];

        const columnTitles = columns.map(columnDef => columnDef.title);

        const FileData = exchnagetra.map(rowData =>
            [rowData["transaction_hash"],
            rowData["created_datetime"],
            rowData["exchange_type"],
            rowData["exchnage_pair"],
            rowData["fee"],
            rowData["fiat_amount"],
            rowData["crypto_amount"],
            rowData["transfer_statusText"]]
        );
        if (val === "CSV") {
            const builder = new CsvBuilder(FileName + `.csv`)
                .setColumns(columnTitles)
                .addRows(FileData)
                .exportFile();

            return builder;
        }
        else if (val === "PDF") {
            const doc = new jsPDF();

            doc.autoTable({
                head: [columnTitles],
                body: FileData,
            });

            doc.save(FileName + `.pdf`);
        }
    }

    const getbuylimit = (type, fiatcoin, cryptocoinid ) => {

        if(type=="sell"){
            if(!fiatcoin || fiatcoin =="" || !cryptocoinid || cryptocoinid ==""){
                return;
            }
        }


        let jsonpar = {
            coinname: fiatcoin,
        }
        const headers = {
            'Content-Type': 'application/json',
            'useraccesstoken': process.env.REACT_APP_USER_ACCESS_TOKEN,
            'userauthtoken': 'Bearer ' + window.sessionStorage.getItem("user_jwt"),
        }
        setLoader(true);
        axios.post(process.env.REACT_APP_API_URL + 'limits/getbaselimit', jsonpar, { headers: headers })
            .then(function (res) {
                res = res.data;
                if (res.code === "200") {
                    console.log(res.cryptoexchangerates)
                    if(type=='buy'){
                        setbuyminamount(res.minbuycryptolimit);
                        setbuymaxamount(res.maxbuycryptolimit);
                    }
                    if(type=='swap'){
                        let cryptocoin = "BTC"
                        allcrypto.forEach(element => {
                            if (element.coin_code === cryptocoinid) {
                                cryptocoin = element.coin_code
                            }
                        });
                        const pair = `${cryptocoin}_USD`;
                        if(pair=="USDC_USD"){
                            setswapminamount((res.minswapcryptolimit / 1));
                            setswapmaxamount((res.maxswapcryptolimit / 1));
                        }else{
                        setswapminamount((res.minswapcryptolimit / res.cryptoexchangerates[pair].last_price).toFixed(8));
                        setswapmaxamount((res.maxswapcryptolimit / res.cryptoexchangerates[pair].last_price).toFixed(8));
                        }
                    }

                    if(type == "sell"){
                        let cryptocoin = "BTC"
                        allcrypto.forEach(element => {
                            if (element.crypto_id === cryptocoinid) {
                                cryptocoin = element.coin_code
                            }
                        });
    
                        const pair = `${cryptocoin}_${fiatcoin}`;
                        if(pair=="USDC_USD"){
                            setsellminamount((res.minsellcryptolimit / 1));
                            setsellmaxamount((res.maxsellcryptolimit / 1));
                        }else{
                            setsellminamount((res.minsellcryptolimit / res.cryptoexchangerates[pair].last_price).toFixed(8));
                            setsellmaxamount((res.maxsellcryptolimit / res.cryptoexchangerates[pair].last_price).toFixed(8));
                        }
                    }
                    
                    setLoader(false);
                } else {
                    setLoader(false);
                }
            })
            .catch(function (error) {
                setLoader(false);
            });
    }

    const pageReload = () => {
        window.location.reload();

        setTransferAcceptBuy(false);
        setTransferAcceptSell(false);
        setTransferAcceptSwap(false);
    }


    return (
        <div>
            {error ? <Snackbars open_close={error} type="error" message={error_msg} /> : ""}
            {success ? <Snackbars open_close={success} type="success" message={success_msg} /> : ""}
            {/* <div className="breaking-news bg-primary">
                <div ref={ref} />
            </div> */}
            {/* <p> We're actively upgrading our platform. If you face any issues, please be assured our team is addressing them promptly.</p> */}

            <div className="card bg-0 bg-none">
                <div className="card-header page-title-space mobile-card-header"> 
                    <h2 className="text-black font-w500 mb-0">{t("CRYPTOTRANSACTION.CRYPTO_EX_LABEL")}</h2>
                </div>
            </div>
            <ul className="nav nav-tabs crypto-tabs-btn">
                <li className="nav-item" onClick={() => setActiveToggle("posts")}>
                    <Link to="#01" data-toggle="tab" className={`nav-link ${activeToggle === "posts" ? "active show" : ""}`}><i className="flaticon-381-add-1 mt-1"></i>&nbsp; {t("CRYPTOTRANSACTION.BUY_TITLE")}</Link>
                </li>
                <li className="nav-item" onClick={() => setActiveToggle("aboutMe")}>
                    <Link to="#02" data-toggle="tab" className={`nav-link ${activeToggle === "aboutMe" ? "active show" : ""}`}><i className="flaticon-381-substract-2 mt-1"></i>&nbsp; {t("CRYPTOTRANSACTION.SELL_TITLE")}</Link>
                </li>
                <li className="nav-item">
                    <Link to="#03" data-toggle="tab" onClick={() => setActiveToggle("setting")} className={`nav-link ${activeToggle === "setting" ? "active show" : ""}`}><i className="fa fa-exchange mt-1"></i>&nbsp; {t("CRYPTOTRANSACTION.SWAP_TITLE")}</Link>
                </li>

            </ul>
            {loader === true ?
                <div>
                    <Loader open_close={loader} />
                </div>
                :
                <div className="card">
                    <div className="card-body bdr-btm-card">
                        <div className="custom-tab-1 setTabDesignbtn">

                            <div className="tab-content">
                                <div id="01" className={`tab-pane fade ${activeToggle === "posts" ? "active show" : ""}`} >
                                    <div className="profile-personal-info">
                                        <div className="row position-relative z-111">
                                        <div className="col-md-6">
                                                <div className="form-group position-relative">
                                                    <label className="mb-2 ">
                                                        <span>Choose the fiat account type for the purchase</span>
                                                    </label>
                                                    <select className="form-control webkit-none" id="sel1" onChange={(e) => validateAccount(e.target.value)} value={buy_account}>
                                                        <option value="">Select Fiat</option>
                                                        {allaccount && allaccount.map((row) => (
                                                            <option value={row.account_id_pk + "|" + row.account_currency_type} key={row.account_id_pk}> {row.account_currency_type} AC ({row.account_balance})</option>
                                                        ))}
                                                    </select>
                                                    <i className="fa fa-caret-down down-arrow" aria-hidden="true"></i>
                                                </div>
                                                {buy_account_error !== "" ? <label className='text-red'>{buy_account_error}</label> : ""}
                                            </div>

                                            <div className="col-md-6">
                                                <div className="form-group position-relative">
                                                    <label className="mb-2 ">
                                                        <span>Select the cryptocurrency to purchase</span>
                                                    </label>
                                                    <select className="form-control webkit-none" id="sel1" onChange={(e) => validateCrypto(e.target.value)} value={buy_crypto}>
                                                        <option value="">Select Crypto</option>
                                                        {allcrypto && allcrypto.map((row) => (
                                                            <option value={row.crypto_id} key={row.crypto_wallet_id}>{row.coin_code} {row.coin_code =="USDC"? "(ERC 20)": ""}</option>
                                                        ))}
                                                    </select>
                                                    <i className="fa fa-caret-down down-arrow" aria-hidden="true"></i>
                                                </div>
                                                {buy_crypto_error !== "" ? <label className='text-red'>{buy_crypto_error}</label> : ""}
                                            </div>
                                            
                                            <div className="col-md-6">
                                                <div className="form-group ">
                                                    <label className="mb-2 "><span>Enter the amount of {buy_account == "" ? "fiat" : buy_account.split("|")[1]} to buy</span></label>
                                                    <input type="number" className="form-control" onChange={(e) => validateAmount(e.target.value)} value={buy_amount} placeholder={buy_account == "" ? "Please enter fiat amount" : "Please enter "+buy_account.split("|")[1]+" amount"} />
                                                    {buy_amount_error !== "" ? <label className='text-red'>{buy_amount_error}</label> : ""}
                                                </div>
                                            </div>
                                            
                                            {parseFloat(buyminamount) > 0 ?
                                                <div className="col-md-12 mt-4">
                                                    <label className="mb-2 mr-3 minmaxclass"> <span>Minimum Buy Amount = {buyminamount} {buy_account.split("|")[1]}</span></label>
                                                    <label className="mb-2 minmaxclass"> <span>Maximum Buy Amount = {buymaxamount} {buy_account.split("|")[1]}</span></label>
                                                </div>
                                                : ""}
                                            <div className="col-md-12">
                                                {/* {buy_acc_div === true ?
                                                    <>
                                                    <p className="mt-4 mb-0 highlight-text-coin">{t('CRYPTOTRANSACTION.TOTAL')} : <strong>{buy_select_value} {buy_select_acc} </strong> </p>
                                                    <p  className="mt-0 mb-4">( Fees Included : {buy_select_fee} {buy_select_acc}) </p>
                                                    </>
                                                    : ""} */}
                                                <button type="button" onClick={accountchnagerate} className="btn btn-primary btn-rounded">{t('CRYPTOTRANSACTION.BUY_TITLE')}</button>
                                                {/* {buy_crypto_div === true ?
                                                    <p className="mt-5">1 {buy_coin_name} = <strong>{buy_usd_value} </strong></p>
                                                    : ""} */}
                                            </div>
                                        </div>

                                    </div>
                                </div>
                                <div id="02" className={`tab-pane fade ${activeToggle === "aboutMe" ? "active show" : ""}`}>
                                    <div className="profile-personal-info">
                                        <div className="row position-relative z-111">
                                            <div className="col-md-6">
                                                <div className="form-group position-relative">
                                                    <label className="mb-2 ">
                                                        <span>Select the cryptocurrency to sell </span>
                                                    </label>
                                                    <select className="form-control webkit-none" id="sel1" onChange={(e) => validateCryptoSell(e.target.value)} value={sell_crypto}>
                                                        <option value="">Select Crypto</option>
                                                        {allcrypto && allcrypto.map((row) => (
                                                            <option value={row.crypto_id} key={row.crypto_wallet_id}>{row.coin_code} {row.coin_code =="USDC"? "(ERC 20)": ""} { "(" + row.total_available  + ")"}</option>
                                                        ))}
                                                    </select>
                                                    <i className="fa fa-caret-down down-arrow" aria-hidden="true"></i>
                                                </div>
                                                {sell_crypto_error !== "" ? <label className='text-red'>{sell_crypto_error}</label> : ""}
                                            </div>
                                            
                                            <div className="col-md-6">
                                                <div className="form-group position-relative">
                                                    <label className="mb-2 ">
                                                        <span>Choose the fiat account type for receiving the fiat amount</span>
                                                    </label>
                                                    <select className="form-control webkit-none" id="sel1" onChange={(e) => validateAccountSell(e.target.value)} value={sell_account}>
                                                        <option value="">Select Fiat</option>
                                                        {allaccount && allaccount.map((row) => (
                                                            <option value={row.account_id_pk + "|" + row.account_currency_type} key={row.account_id_pk}>{row.account_currency_type} AC   </option>
                                                        ))}
                                                    </select>
                                                    <i className="fa fa-caret-down down-arrow" aria-hidden="true"></i>
                                                </div>
                                                {sell_account_error !== "" ? <label className='text-red'>{sell_account_error}</label> : ""}
                                            </div>
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label className="mb-2 "><span>Enter the amount of cryptocurrency to sell</span></label>
                                                    <input type="number" className="form-control" onChange={(e) => validateAmountSell(e.target.value)} value={sell_amount} placeholder={sellcurrency == "" ? "Please enter crypto amount" : "Please enter "+sellcurrency+" amount"}/>
                                                    {sell_amount_error !== "" ? <label className='text-red'>{sell_amount_error}</label> : ""}
                                                </div>
                                            </div>
                                            {parseFloat(sellminamount) > 0 ?
                                                <div className="col-md-12 mt-4">
                                                    <label className="mb-2 mr-3 minmaxclass"><span>Minimum Amount = {sellminamount} {sellcurrency} </span></label>
                                                    <label className="mb-2 minmaxclass"><span>Maximum Amount = {sellmaxamount} {sellcurrency}</span></label>
                                                </div>
                                                : ""}
                                            <div className="col-md-12">
                                                {/* {sell_acc_div === true ?
                                                    <p className="mt-1 mb-4 highlight-text-coin">{t('CRYPTOTRANSACTION.TOTAL')} : <strong>{sell_select_value} {sell_select_acc} </strong></p>
                                                    : ""} */}
                                                <button type="button" onClick={accountchnageratesell} className="btn btn-primary btn-rounded">{t('CRYPTOTRANSACTION.SELL_TITLE')}</button>
                                                {/* {sell_crypto_div === true ?
                                                    <p className="mt-5">1 {sell_coin_name} = <strong>{sell_usd_value} </strong> </p>
                                                    : ""} */}
                                            </div>
                                        </div>

                                    </div>
                                </div>
                                <div id="03" className={`tab-pane fade ${activeToggle === "setting" ? "active show" : ""}`}>
<div className="profile-personal-info">
    <div className="row position-relative z-111">
        <div className="col-md-6">
            <div className="form-group position-relative">
                {/* <label className="form-label to-hightlight">{t('FIAT.FROM')}</label> */}
                <label className="mb-2 ">
                    <span>From cryptocurrency asset </span>
                </label>
                <select className="form-control webkit-none" id="sel1" onChange={(e) => validateCryptoSwapFrom(e.target.value)} value={swap_from_crypto}>
                    <option value="">{t("CRYPTOTRANSACTION.SELECTCOIN")}</option>
                    {allcrypto && allcrypto.map((row) => (
                        <option value={row.coin_code} key={row.crypto_wallet_id}>{row.coin_code} {row.coin_code =="USDC"? "(ERC 20)": ""} { "(" + row.total_available  + ")"}</option>
                    ))}
                </select>
                <i className="fa fa-caret-down down-arrow" aria-hidden="true"></i>
            </div>
            {swap_from_crypto_error !== "" ? <label className='text-red'>{swap_from_crypto_error}</label> : ""}
        </div>
        <div className="col-md-6">
            <div className="form-group position-relative">
                {/* <label className="form-label to-hightlight">{t('FIAT.TO')}</label> */}
                <label className="mb-2 ">
                    <span>To cryptocurrency asset </span>
                </label>
                <select className="form-control webkit-none" id="sel1" onChange={(e) => validateCryptoSwapTo(e.target.value)} value={swap_to_crypto}>
                    <option value="">{t("CRYPTOTRANSACTION.SELECTCOIN")}</option>
                    {allcrypto && allcrypto.map((row) => (
                        <option value={row.coin_code} key={row.crypto_wallet_id}>{row.coin_code} {row.coin_code =="USDC"? "(ERC 20)": ""} </option>
                    ))}
                </select>
                <i className="fa fa-caret-down down-arrow" aria-hidden="true"></i>
            </div>
            {swap_to_crypto_error !== "" ? <label className='text-red'>{swap_to_crypto_error}</label> : ""}
        </div>

        <div className="col-md-6">
            <div className="form-group">
                <label className="mb-2 "><span>Enter the amount of cryptocurrency to swap</span></label>
                <input type="number" className="form-control" onChange={(e) => validateAmountSwap(e.target.value)} value={swap_amount} placeholder={swap_from_crypto == "" ? "Please enter crypto amount" : "Please enter "+swap_from_crypto+" amount"} />
                {swap_amount_error !== "" ? <label className='text-red'>{swap_amount_error}</label> : ""}
            </div>
        </div>



        {/* <div className="col-md-12 mb-5">
            <button type="button" className="exchange-max">Exchange Max</button>
        </div> */}
        {parseFloat(swapminamount) > 0 ?
            <div className="col-md-12 mt-4">
                <label className="mb-2 mr-3 minmaxclass"><span>Minimum Amount = {swapminamount} {swap_from_crypto}</span></label>
                <label className="mb-2 minmaxclass"><span>Maximum Amount = {swapmaxamount} {swap_from_crypto}</span></label>
            </div>
            : ""}
        <div className="col-md-12">
            <button type="button" onClick={accountchnagerateswap} className="btn btn-primary btn-rounded">Swap</button>
        </div>
    </div>

</div>
</div>
                            </div>
                        </div>
                    </div>
                </div>
            }
            {loader === true ?
                <div>
                    <Loader open_close={loader} />
                </div>
                :
                <div className="card hide-scrolllbar">
                    <div className="card-body">
                        <div className="position-relative">
                            <div className="table-responsive">
                                {exchnagetra.length > 0 ?
                                    <MaterialTable
                                        title={t("TRANSACTION.BUYSELLLA")}
                                        columns={[
                                            { title: t("TRANSACTION.TRA_ID"), field: 'transaction_hash', },
                                            { title: t("TRANSACTION.DATE_LA"), field: 'created_datetime',
                                                render: rowData => (
                                                    <div>
                                                        {moment(rowData.created_datetime).format('MMMM D, YYYY')} <br />
                                                        {moment(rowData.created_datetime).format('hh:mm:ss A')}
                                                    </div>
                                                )
                                             },
                                            { title: t("TRANSACTION.TYPE"), field: 'exchange_type' },
                                            { title: t("TRANSACTION.PAIR"), field: 'exchnage_pair', },
                                            { title: "Crypto Amount", field: 'crypto_amount',align: 'right'},
                                            { title: t("TRANSACTION.FIAT_AMOUNT"), field: 'fiat_amount',align: 'right'},
                                            { title: "Fee", field: 'fee',align: 'right'},
                                            { title: t("TRANSACTION.STATUS_LA"), field: 'transfer_status' },
                                        ]}
                                        data={exchnagetra}
                                        options={{
                                            exportMenu: [
                                                { label: "Export PDF", exportFunc: (cols, datas) => handleChangeCSVNdPDFsecond("PDF") },
                                                { label: "Export CSV", exportFunc: (cols, datas) => handleChangeCSVNdPDFsecond("CSV") },
                                            ], paging: true, pageSize: 5, pageSizeOptions: [5, 10, 15], emptyRowsWhenPaging: false,
                                        }}
                                    />
                                    : <div className="d-sm-flex d-block border-0 pb-0">
                                        <div className="pr-3 mr-auto mb-sm-0 mb-3 nofoundFullWidth">
                                            <h4 className="fs-20 text-black mb-1 nofoundTitle">{t("TRANSACTION.BUYSELLLA")} Overview</h4>
                                            <span className="fs-12 nofoundText">No Data Found</span>
                                        </div>
                                    </div>}
                            </div>
                        </div>
                    </div>
                </div>
            }
            {loader === true ?
                <div>
                    <Loader open_close={loader} />
                </div>
                :
                <div className="card">
                    <div className="card-body">
                        <div className="position-relative">
                            <div className="table-responsive">
                                {swaptra.length > 0 ?
                                    <MaterialTable
                                        title={t("TRANSACTION.SWAP_TRA_LA")}
                                        columns={[
                                            { title: t("TRANSACTION.TRA_ID"), field: 'transaction_hash', },
                                            { title: t("TRANSACTION.DATE_LA"), field: 'created_datetime' },
                                            { title: t("FIAT.FROM_AMOUNT"), field: 'from_amount' },
                                            // { title: t("FIAT.FROM"), field: 'from_coin' },
                                            { title: t("FIAT.TO_AMOUNT"), field: 'to_amount' },
                                            // { title: t("FIAT.TO"), field: 'to_coin' },
                                            { title: "Site Fee", field: 'Fees',align: 'right'},
                                            { title: t("TRANSACTION.STATUS_LA"), field: 'swap_status' },
                                        ]}
                                        data={swaptra}
                                        options={{
                                            exportMenu: [
                                                { label: "Export PDF", exportFunc: (cols, datas) => handleChangeCSVNdPDF("PDF") },
                                                { label: "Export CSV", exportFunc: (cols, datas) => handleChangeCSVNdPDF("CSV") },
                                            ], paging: true, pageSize: 5, pageSizeOptions: [5, 10, 15], emptyRowsWhenPaging: false,
                                        }}
                                    />
                                    : <div className="d-sm-flex d-block border-0 pb-0">
                                        <div className="pr-3 mr-auto mb-sm-0 mb-3 nofoundFullWidth">
                                            <h4 className="fs-20 text-black mb-1 nofoundTitle">{t("TRANSACTION.SWAP_TRA_LA")} Overview</h4>
                                            <span className="fs-12 nofoundText">No Data Found</span>
                                        </div>
                                    </div>}
                            </div>
                        </div>
                    </div>
                </div>
            }

            {loader === true ?
                <div>
                    <Loader open_close={loader} />
                </div>
                :
                <Modal className="modal fade" show={OTPVerification}>
                    <div className="modal-dialog-centered " >
                        <div className="modal-content">
                            <div className="modal-header">
                                <h3 className="modal-title">{t("LABEL.GOOGLE_AUTHENTICATOR_TITLE")}</h3>
                                <button type="button" className="close" onClick={() => setOTPVerification(false)}><span>&times;</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className="form-group">
                                            <label className="mb-2 ">{t("LABEL.GOOGLE_AUTHENTICATOR_TITLE")}</label>
                                            <input type="text" minLength={6} maxLength={6} className="form-control" onChange={(e) => validateGoogleAuth(e.target.value)} value={google_auth} placeholder={t("LABEL.ENTER_GOOGLE_AUTH_CODE")} />
                                            {google_auth_error !== "" ? <label className='text-red'>{google_auth_error}</label> : ""}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button className="btn btn-light btn-rounded light" onClick={() => setOTPVerification(false)}>{t("BUTTONS.CANCEL")}</button>
                                <button type="button" onClick={finalbuysubmit} className="btn btn-primary btn-rounded">{t("BUTTONS.SUBMIT")}</button>
                            </div>
                        </div>
                    </div>
                </Modal>
            }

            {loader === true ?
                <div>
                    <Loader open_close={loader} />
                </div>
                :
                <Modal className="modal fade" show={SMSOTPVerification}>
                    <div className="modal-dialog-centered " >
                        <div className="modal-content">
                            <div className="modal-header">
                                <h3 className="modal-title">{t('FIAT.OTPVERIFICATION_TITLE')}</h3>
                                <button type="button" className="close" onClick={() => setSMSOTPVerification(false)}><span>&times;</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className="form-group">
                                            <label className="mb-2 ">{t('FIAT.OTP_CODE_TITLE')}</label>
                                            <input type="text" minLength={6} maxLength={6} onChange={(e) => validateCodeBuy(e.target.value)} value={buyotpmessage} className="form-control" placeholder={t('FIAT.OTP_CODE_PLACE')} />
                                            <p className="resendcode"><Link to="#" onClick={resendotp}>{t('FIAT.RESEND_OTP')}</Link></p>
                                            <label className="mb-2 ">{"OTP is sent to your registered mobile number."}</label>
                                        </div>
                                        {buyotpmessage_error !== "" ? <label className='text-red'>{buyotpmessage_error}</label> : ""}
                                    </div>
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-light btn-rounded light" onClick={() => setSMSOTPVerification(false)}>{t('BUTTONS.CANCEL')}</button>
                                <button type="button" onClick={finalbuysubmit} className="btn btn-primary btn-rounded">{t('BUTTONS.SUBMIT')}</button>
                            </div>
                        </div>
                    </div>
                </Modal>
            }


            {loader === true ?
                <div>
                    <Loader open_close={loader} />
                </div>
                :
                <Modal className="modal fade" show={SMSOTPVerificationSell}>
                    <div className="modal-dialog-centered " >
                        <div className="modal-content">
                            <div className="modal-header">
                                <h3 className="modal-title">{t('FIAT.OTPVERIFICATION_TITLE')}</h3>
                                <button type="button" className="close" onClick={() => setSMSOTPVerificationSell(false)}><span>&times;</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className="form-group">
                                            <label className="mb-2 ">{t('FIAT.OTP_CODE_TITLE')}</label>
                                            <input type="text" minLength={6} maxLength={6} onChange={(e) => validateCodeSell(e.target.value)} value={sellotpmessage} className="form-control" placeholder={t('FIAT.OTP_CODE_PLACE')} />
                                            <p className="resendcode"><Link to="#" onClick={resendotp}>{t('FIAT.RESEND_OTP')}</Link></p>
                                            <label className="mb-2 ">{"OTP is sent to your registered mobile number."}</label>
                                        </div>
                                        {sellotpmessage_error !== "" ? <label className='text-red'>{sellotpmessage_error}</label> : ""}
                                    </div>
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-light btn-rounded light" onClick={() => setSMSOTPVerificationSell(false)}>{t('BUTTONS.CANCEL')}</button>
                                <button type="button" onClick={finalsellsubmit} className="btn btn-primary btn-rounded">{t('BUTTONS.SUBMIT')}</button>
                            </div>
                        </div>
                    </div>
                </Modal>
            }

            {loader === true ?
                <div>
                    <Loader open_close={loader} />
                </div>
                :
                <Modal className="modal fade" show={SMSOTPVerificationSwap}>
                    <div className="modal-dialog-centered " >
                        <div className="modal-content">
                            <div className="modal-header">
                                <h3 className="modal-title">{t('FIAT.OTPVERIFICATION_TITLE')}</h3>
                                <button type="button" className="close" onClick={() => setSMSOTPVerificationSwap(false)}><span>&times;</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className="form-group">
                                            <label className="mb-2 ">{t('FIAT.OTP_CODE_TITLE')}</label>
                                            <input type="text" minLength={6} maxLength={6} onChange={(e) => validateCodeSwap(e.target.value)} value={swapotpmessage} className="form-control" placeholder={t('FIAT.OTP_CODE_PLACE')} />
                                            <p className="resendcode"><Link to="#" onClick={resendotp}>{t('FIAT.RESEND_OTP')}</Link></p>
                                            <label className="mb-2 ">{"OTP is sent to your registered mobile number."}</label>
                                        </div>
                                        {swapotpmessage_error !== "" ? <label className='text-red'>{swapotpmessage_error}</label> : ""}
                                    </div>
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-light btn-rounded light" onClick={() => setSMSOTPVerificationSwap(false)}>{t('BUTTONS.CANCEL')}</button>
                                <button type="button" onClick={finalswapsubmit} className="btn btn-primary btn-rounded">{t('BUTTONS.SUBMIT')}</button>
                            </div>
                        </div>
                    </div>
                </Modal>
            }






            {loader === true ?
                <div>
                    <Loader open_close={loader} />
                </div>
                :
                <Modal className="modal fade" show={OTPVerificationSell}>
                    <div className="modal-dialog-centered " >
                        <div className="modal-content">
                            <div className="modal-header">
                                <h3 className="modal-title">{t("LABEL.GOOGLE_AUTHENTICATOR_TITLE")}</h3>
                                <button type="button" className="close" onClick={() => setOTPVerificationSell(false)}><span>&times;</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className="form-group">
                                            <label className="mb-2 ">{t("LABEL.GOOGLE_AUTHENTICATOR_TITLE")} </label>
                                            <input type="text" minLength={6} maxLength={6} className="form-control" onChange={(e) => validateGoogleAuthSell(e.target.value)} value={google_auth_sell} placeholder={t("LABEL.ENTER_GOOGLE_AUTH_CODE")} />
                                            {google_auth_sell_error !== "" ? <label className='text-red'>{google_auth_sell_error}</label> : ""}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button className="btn btn-light btn-rounded light" onClick={() => setOTPVerificationSell(false)}>{t("BUTTONS.CANCEL")}</button>
                                <button type="button" onClick={finalsellsubmit} className="btn btn-primary btn-rounded">{t("BUTTONS.SUBMIT")}</button>
                            </div>
                        </div>
                    </div>
                </Modal>
            }

            {loader === true ?
                <div>
                    <Loader open_close={loader} />
                </div>
                :
                <Modal className="modal fade" show={OTPVerificationSwap}>
                    <div className="modal-dialog-centered " >
                        <div className="modal-content">
                            <div className="modal-header">
                                <h3 className="modal-title">{t("LABEL.GOOGLE_AUTHENTICATOR_TITLE")}</h3>
                                <button type="button" className="close" onClick={() => setOTPVerificationSwap(false)}><span>&times;</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className="form-group">
                                            <label className="mb-2 ">{t("LABEL.GOOGLE_AUTHENTICATOR_TITLE")} </label>
                                            <input type="text" minLength={6} maxLength={6} className="form-control" onChange={(e) => validateGoogleAuthSwap(e.target.value)} value={google_auth_swap} placeholder={t("LABEL.ENTER_GOOGLE_AUTH_CODE")} />
                                            {google_auth_swap_error !== "" ? <label className='text-red'>{google_auth_swap_error}</label> : ""}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button className="btn btn-light btn-rounded light" onClick={() => setOTPVerificationSwap(false)}>{t("BUTTONS.CANCEL")}</button>
                                <button type="button" onClick={finalswapsubmit} className="btn btn-primary btn-rounded">{t("BUTTONS.SUBMIT")}</button>
                            </div>
                        </div>
                    </div>
                </Modal>
            }
            {loader === true ?
                <div>
                    <Loader open_close={loader} />
                </div>
                :
                <Modal className="modal fade" show={TransactionDetails}>
                    <div className="modal-dialog-centered " >
                        <div className="modal-content">
                            <div className="modal-header">
                                <h3 className="modal-title">{t("TRANSACTION.TRANSACTION_DETAILS")}</h3>
                                <button type="button" className="close" onClick={() => setTransactionDetails(false)}><span>&times;</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                <p className="Deduction-text">{t("CRYPTOTRANSACTION.TOTAL")} {swap_from_crypto} {t("CRYPTOTRANSACTION.DEDUCTION")} : <strong> {swap_popup_from_value} {swap_from_crypto}</strong></p>
                                <p className="text-success collect">{swap_to_crypto} : <strong> {swap_popup_to_value} {swap_to_crypto}</strong></p>
                            </div>
                            <div className="modal-footer">
                                <button onClick={finalauthubmit} className="btn btn-light btn-rounded light">{t("BUTTONS.SUBMIT")}</button>
                                <button onClick={() => setTransactionDetails(false)} className="btn btn-primary btn-rounded">{t("BUTTONS.CANCEL")}</button>
                            </div>
                        </div>
                    </div>
                </Modal>
            }


            <Modal className="modal fade" show={TransferAcceptBuy}>
                <div className="modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h3 className="modal-title">Buy Crypto Transaction</h3>
                            <button type="button" className="close" onClick={pageReload}><span>&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="check">
                                <i class="fa fa-solid fa-check"></i>
                                <p className="fs-14 mb-1 Submitted">Buy Crypto Transaction Success</p>
                            </div>
                            {success_display_credited_amount_buy === "" || success_display_credited_amount_buy === undefined || success_display_credited_amount_buy === null ? " " :
                                <>
                                

                                    

                                    <div className="row">
                                        <div className="col-md-12 mb-1">
                                            <p className="fs-16 mb-1">Order Amount : <span className="text-black">{success_display_debit_fiat_amount_buy} {success_display_debited_cur_buy}</span></p>
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-md-12 mb-1">
                                            <p className="fs-16 mb-1">Credit Amount : <span className="text-black">{success_display_credited_amount_buy}</span></p>
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-md-12 mb-1">
                                            <p className="fs-16 mb-1">Debited from {success_display_debited_cur_buy} account : <span className="text-black">{success_display_debited_account_buy}</span></p>
                                        </div>
                                    </div>

                                    

                                    <div className="row">
                                        <div className="col-md-12 mb-1">
                                            <p className="fs-16 mb-1">Reference Number : <span className="text-black">{success_display_refno_buy}</span></p>
                                        </div>
                                    </div>
                                </>
                            }

                            {/* <div className="row mt-1">
                                <div className="col-md-12 mb-3">
                                    <p className="fs-16 mb-1">Details</p>
                                    <span className="text-black">{success_display_details_buy}</span>
                                </div>
                            </div> */}
                            <div className="row mt-3 mb-2">
                                <ul className="btm-link">
                                    <li>
                                        <Link to="#" onClick={pageReload}> New Buy Crypto Order</Link>
                                    </li>
                                    <li>
                                        <Link to="/dashboard"> Dashboard</Link>
                                    </li>
                                    <li>
                                        <Link to="/crypto-transactions"> Transaction List</Link>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal>

            <Modal className="modal fade" show={TransferAcceptSell}>
                <div className="modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h3 className="modal-title">Sell Crypto Transaction</h3>
                            <button type="button" className="close" onClick={pageReload}><span>&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="check">
                                <i class="fa fa-solid fa-check"></i>
                                <p className="fs-14 mb-1 Submitted">Sell Crypto Transaction Success</p>
                            </div>
                            {success_display_credited_amount_sell === "" || success_display_credited_amount_sell === undefined || success_display_credited_amount_sell === null ? " " :
                                <>
                                

                                   

                                    <div className="row">
                                        <div className="col-md-12 mb-1">
                                            <p className="fs-16 mb-1">Order Amount : <span className="text-black">{success_display_debit_fiat_amount_sell} {success_display_debited_cur_sell}</span></p>
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-md-12 mb-1">
                                            <p className="fs-16 mb-1">Credited Amount : <span className="text-black">{success_display_credited_amount_sell}</span></p>
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-md-12 mb-1">
                                            <p className="fs-16 mb-1">Debited from {success_display_debited_cur_sell} wallet : <span className="text-black">{success_display_debited_account_sell}</span></p>
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-md-12 mb-1">
                                            <p className="fs-16 mb-1">Reference Number : <span className="text-black">{success_display_refno_sell}</span></p>
                                        </div>
                                    </div>
                                </>
                            }

                            
                            <div className="row mt-3 mb-2">
                                <ul className="btm-link">
                                    <li>
                                        <Link to="#" onClick={pageReload}> New Sell Crypto Order</Link>
                                    </li>
                                    <li>
                                        <Link to="/dashboard"> Dashboard</Link>
                                    </li>
                                    <li>
                                        <Link to="/crypto-transactions"> Transaction List</Link>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal>


            <Modal className="modal fade" show={TransferAcceptSwap}>
<div className="modal-dialog-centered">
    <div className="modal-content">
        <div className="modal-header">
            <h3 className="modal-title">Swap Crypto Transaction</h3>
            <button type="button" className="close" onClick={pageReload}><span>&times;</span>
            </button>
        </div>
        <div className="modal-body">
            <div className="check">
                <i class="fa fa-solid fa-check"></i>
                <p className="fs-14 mb-1 Submitted">Swap Crypto Transaction Success</p>
            </div>
            {success_display_credited_amount_swap === "" || success_display_credited_amount_swap === undefined || success_display_credited_amount_swap === null ? " " :
                <>
                   

                    <div className="row">
                        <div className="col-md-12 mb-1">
                            <p className="fs-16 mb-1">Order Amount : <span className="text-black">{success_display_debit_fiat_amount_swap} {success_display_debited_cur_swap}</span></p>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-12 mb-1">
                            <p className="fs-16 mb-1">Credited Amount : <span className="text-black">{success_display_credited_amount_swap}</span></p>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-12 mb-1">
                            <p className="fs-16 mb-1">Debited from {success_display_debited_cur_swap} wallet : <span className="text-black">{success_display_debited_account_swap}</span></p>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-12 mb-1">
                            <p className="fs-16 mb-1">Reference Number : <span className="text-black">{success_display_refno_swap}</span></p>
                        </div>
                    </div>
                </>
            }

            <div className="row mt-3 mb-2">
                <ul className="btm-link">
                    <li>
                        <Link to="#" onClick={pageReload}> New Swap Crypto Order</Link>
                    </li>
                    <li>
                        <Link to="/dashboard"> Dashboard</Link>
                    </li>
                    <li>
                        <Link to="/crypto-transactions"> Transaction List</Link>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</div>
</Modal>

            <Modal className="modal fade" show={TransferDeclineBuy}>
                <div className="modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h3 className="modal-title">Buy Crypto Order</h3>
                            <button type="button" className="close" onClick={() => setTransferDeclineBuy(false)}><span>&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="check">
                                <i class="fa fa-solid fa-times"></i>
                                <p className="fs-14 mb-1 Submitted">Transaction Failed</p>
                            </div>

                            <div className="row">
                                <div className="col-md-12 mb-1">
                                    <p className="fs-16 mb-1">Amount : <span className="text-black">{error_display_amount_buy}</span></p>
                                </div>
                            </div>

                            {/* <div className="row mt-1">
                                <div className="col-md-12 mb-3">
                                    <p className="fs-16 mb-1">Details</p>
                                    <span className="text-black">{error_display_details_buy}</span>
                                </div>
                            </div> */}
                            <div className="row mt-3 mb-2">
                                <ul className="btm-link">
                                    <li>
                                        <Link to="#" onClick={() => setTransferDeclineBuy(false)}> Retry </Link>
                                    </li>
                                    <li>
                                        <Link to="/dashboard"> Dashboard</Link>
                                    </li>
                                    <li>
                                        <Link to="/crypto-transactions"> Transaction List</Link>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal>


            <Modal className="modal fade" show={TransferDeclineSell}>
                <div className="modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h3 className="modal-title">Sell Crypto Order</h3>
                            <button type="button" className="close" onClick={() => setTransferDeclineSell(false)}><span>&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="check">
                                <i class="fa fa-solid fa-times"></i>
                                <p className="fs-14 mb-1 Submitted">Transaction Failed</p>
                            </div>

                            <div className="row">
                                <div className="col-md-12 mb-1">
                                    <p className="fs-16 mb-1">Amount : <span className="text-black">{error_display_amount_sell}</span></p>
                                </div>
                            </div>

                            <div className="row mt-1">
                                <div className="col-md-12 mb-3">
                                    <p className="fs-16 mb-1">Details</p>
                                    <span className="text-black">{error_display_details_sell}</span>
                                </div>
                            </div>
                            <div className="row mt-3 mb-2">
                                <ul className="btm-link">
                                    <li>
                                        <Link to="#" onClick={() => setTransferDeclineSell(false)}> Retry </Link>
                                    </li>
                                    <li>
                                        <Link to="/dashboard"> Dashboard</Link>
                                    </li>
                                    <li>
                                        <Link to="/crypto-transactions"> Transaction List</Link>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal>


            <Modal className="modal fade" show={TransferDeclineSwap}>
                <div className="modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h3 className="modal-title">Swap Crypto Order</h3>
                            <button type="button" className="close" onClick={() => setTransferDeclineSwap(false)}><span>&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="check">
                                <i class="fa fa-solid fa-times"></i>
                                <p className="fs-14 mb-1 Submitted">Transaction Failed</p>
                            </div>

                            <div className="row">
                                <div className="col-md-12 mb-1">
                                    <p className="fs-16 mb-1">Amount : <span className="text-black">{error_display_amount_swap}</span></p>
                                </div>
                            </div>

                            <div className="row mt-1">
                                <div className="col-md-12 mb-3">
                                    <p className="fs-16 mb-1">Details</p>
                                    <span className="text-black">{error_display_details_swap}</span>
                                </div>
                            </div>
                            <div className="row mt-3 mb-2">
                                <ul className="btm-link">
                                    <li>
                                        <Link to="#" onClick={() => setTransferDeclineSwap(false)}> Retry </Link>
                                    </li>
                                    <li>
                                        <Link to="/dashboard"> Dashboard</Link>
                                    </li>
                                    <li>
                                        <Link to="/crypto-transactions"> Transaction List</Link>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal>

            <Modal className="modal fade" show={TransactionPreview}>
                <div className="modal-dialog-centered" >
                    <div className="modal-content">
                        <div className="modal-header">
                            <h3 className="modal-title">Transaction Details</h3>
                            <button type="button" className="close" onClick={() => setTransactionPreview(false)}><span>&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">

                        
                            <div className="row">
                                <div className="col-md-12 mb-1">
                                    <p className="fs-16 mb-1">Order Amount : <span className="text-black">{buy_debit_amount} {buy_debit_currency}</span></p>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-md-12 mb-1">
                                    <p className="fs-16 mb-1">Site Fee : <span className="text-black">{buy_select_fee} {buy_debit_currency}</span></p>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-md-12 mb-1">
                                    <p className="fs-16 mb-1">Exchange Rate : <span className="text-black">{exchangerate1}</span></p>
                                </div>
                            </div>
                            

                            <div className="row">
                                <div className="col-md-12 mb-1">
                                    <p className="fs-16 mb-1">Credit Amount : <span className="text-black">{buy_select_value} {buy_credit_currency}</span></p>
                                </div>
                            </div>
                            {activeToggle == "posts"?
                                                        <div className="mt-4 flex-wrap border-0 pb-0 align-items-end">
                                                        <Dropdown className="mb-auto">
                                                            <Dropdown.Toggle variant="" as="div" className="btn-link i-false share-info" >
                                                                <i className="fa fa-share-alt-square" aria-hidden="true" style={{ marginRight: '13px' }}></i>
                                                            </Dropdown.Toggle>
                                                            <Dropdown.Menu alignRight={true} className="dropdown-menu-right">
                                                                <CopyToClipboard text={
                                                                    t("FIAT.FIAT_DEPOSIT_LABEL1") + " : " + holdername + "\n" +
                        
                                                                    t("FIAT.FIAT_DEPOSIT_LABEL2") + " : " + account_number + "\n" +
                        
                                                                    t("FIAT.FIAT_DEPOSIT_LABEL3") + " : " + routing_number + "\n" +
                        
                                                                    t("FIAT.FIAT_DEPOSIT_LABEL4") + " : " + swiftcode + "\n" +
                        
                                                                    t("FIAT.FIAT_DEPOSIT_LABEL5") + " : " + bankname + "\n" 
                                                                    }>
                                                                    <Dropdown.Item onClick={clickclip}>{t('HEADER.CLIPBOARD')}</Dropdown.Item>
                                                                </CopyToClipboard>
                                                            </Dropdown.Menu>
                                                        </Dropdown>
                                                        <div className="accordion-body-text mt-2" id="capture">
                                                            <p className="instructions">Admin account details:</p>
                                                            <p className="instructions-details">{t('FIAT.FIAT_DEPOSIT_LABEL1')}: {holdername}</p>
                                                            <p className="instructions-details">{t('FIAT.FIAT_DEPOSIT_LABEL2')}: {account_number}</p>
                                                            <p className="instructions-details">{t('FIAT.FIAT_DEPOSIT_LABEL3')}: {routing_number}</p>
                                                            <p className="instructions-details">{t('FIAT.FIAT_DEPOSIT_LABEL4')}: {swiftcode}</p>
                                                            <p className="instructions-details">{t('FIAT.FIAT_DEPOSIT_LABEL5')}: {bankname}</p>
                                                            {/* <p className="instructions-details-btm mt-2">{t('FIAT.INCOMMING_NOTE_TWO')}</p> */}
                                                        </div>
                                                    </div>
                            :""
                            }

                            
                        </div>

                        <div className="modal-footer">
                            <button className="btn btn-light btn-rounded light" onClick={() => setTransactionPreview(false)}>Close</button>
                            {activeToggle == "posts" ? (
                                <Link to="#" onClick={buysubmit} className="btn btn-primary btn-rounded">Submit</Link>
                            ) : activeToggle == "aboutMe" ? (
                                <Link to="#" onClick={sellsubmit} className="btn btn-primary btn-rounded">Submit</Link>
                            ) : (
                                <Link to="#" onClick={finalauthubmit} className="btn btn-primary btn-rounded">Submit</Link>
                            )}
                        </div>
                    </div>
                </div>
            </Modal>
        </div>
    )

}
export default Crypto_Exchanges;